var $ = require('jquery');
var main = require('./common/main.js');
var msgbox = require('./common/msgbox.js');
var user = require('./common/user.js');
var login = require('./common/login.js');
var template = require('./common/template.js');
var tj = require('./common/tj.js');
var util = require('./common/util.js');
var logistics = require('./tools/logistics.js');


require('./tools/lottery.js');
require('./tools/textSlider.js');

$(document).on('click', '.act_vip', function() {
    var pids = $(this).attr('pids');
    if (pids) {
        pids = new Function('return ' + pids)()
    }
    pay($(this).attr('pid'), pids);
}).on('click', '.act_logistics', function() {
    logistics();
}).on('click', '.act_prize, act_prize_list', function() {
    prizelist();
}).on('click', '.act_address', function() {
    address();
}).on('click', '.act_info', function(){
    var gid =  $(this).attr('gid')

    info(gid)
})

var pay = function(pid, pids) {
    require.ensure(['./tools/vippay.js'], function(require) {
        var pay = require('./tools/vippay.js');
        pay(pid, pids);
    }, 'vippay');
}

pay.after = function(fn) {
    require.ensure('./tools/vippay.js', function(require) {
        var pay = require('./tools/vippay.js');
        pay.after(fn);
    }, 'vippay');
}

var prizelist = function() {
    require.ensure('./tools/prizelist.js', function(require) {
        var prizelist = require('./tools/prizelist.js');
        prizelist();
    }, 'prizelist');
}

var address = function() {
    require.ensure('./tools/prizelist.js', function(require) {
        var prizelist = require('./tools/prizelist.js');
        prizelist.address();
    }, 'prizelist');
}

var info = function(gid){
    require.ensure('./tools/prizelist.js', function(require) {
        var prizelist = require('./tools/prizelist.js');
        prizelist.info(gid);
    }, 'prizelist');
}

window.thunder = function(fn) {
    $(function() {
        fn.call({
            util: util,
            main: main,
            msgbox: msgbox,
            user: user,
            login: login,
            template: template,
            pay: pay,
            tj: tj,
            prizelist: prizelist,
            address: address,
            info: info
        });
        main.start();
        window.thunder === null;
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/entry.js
// module id = 0
// module chunks = 0